module.exports = __webpack_public_path__ + "img/icon_infor2@3x.f471fa62.png";